import { createAction } from 'redux-actions';
import {
  getUserById,
  getDisabledProfile,
  getUserProfile,
  getCurrentUser,
  getResidentProfiles,
  getUserUnits,
  getUserFullName
} from './selectors';
import { serialize } from './serializer';
import verifyAdminPassword from './adminPasswordVerification';
import userWizzardAction from '../users/createWizard/actions';
import { isEmpty } from 'lodash';
import unitsActions from '../units/actions';
import {
  allProfileTypes,
  normalProfileTypes,
  statusTypes
} from '../../constants/profileTypes';

const types = {
  queryUsersSuccess: 'queryUsersSuccess',
  queryUsersInProgress: 'queryUsersInProgress',
  queryUsersFailed: 'queryUsersFailed',
  findUserByIdSuccess: 'findUserByIdSuccess',
  findUserByIdInProgress: 'findUserByIdInProgress',
  findUserByIdFailed: 'findUserByIdFailed',
  updateUserByIdSuccess: 'updateUserByIdSuccess',
  updateUserByIdInProgress: 'updateUserByIdInProgress',
  updateUserByIdFailed: 'updateUserByIdFailed',
  deleteUserByIdSuccess: 'deleteUserByIdSuccess',
  deleteUserByIdInProgress: 'deleteUserByIdInProgress',
  deleteUserByIdFailed: 'deleteUserByIdFailed',
  createUserSuccess: 'createUserSuccess',
  createUserInProgress: 'createUserInProgress',
  createUserFailed: 'createUserFailed',
  sendWelcomeEmailInProgress: 'sendWelcomeEmailInProgress',
  sendWelcomeEmailSuccess: 'sendWelcomeEmailSuccess',
  sendWelcomeEmailFailed: 'sendWelcomeEmailFailed',
  resendInvitationEmailInProgress: 'resendInvitationEmailInProgress',
  resendInvitationEmailSuccess: 'resendInvitationEmailSuccess',
  resendInvitationEmailFailed: 'resendInvitationEmailFailed',
  clearEmailSuccess: 'clearEmailSuccess',
  queryUnitsSuccess: 'queryUnitsSuccess',
  queryUnitsInProgress: 'queryUnitsInProgress',
  queryUnitsFailed: 'queryUnitsFailed',
  clearUnits: 'clearUnits',
  addUnitToSelection: 'addUnitToSelection',
  removeUnitFromSelection: 'removeUnitFromSelection',
  updateSelectedUnitRelationship: 'updateSelectedUnitRelationship',
  assignUnitsToUserSuccess: 'assignUnitsToUserSuccess',
  assignUnitsToUserInProgress: 'assignUnitsToUserInProgress',
  assignUnitsToUserFailed: 'assignUnitsToUserFailed',
  unassignUnitFromUserSuccess: 'unassignUnitFromUserSuccess',
  unassignUnitFromUserInProgress: 'unassignUnitFromUserInProgress',
  unassignUnitFromUserFailed: 'unassignUnitFromUserFailed',
  changeIndividualStatusInCommunityInProgress:
    'changeIndividualStatusInCommunityInProgress',
  changeIndividualStatusInCommunitySuccess:
    'changeIndividualStatusInCommunitySuccess',
  changeIndividualStatusInCommunityFailed:
    'changeIndividualStatusInCommunityFailed',
  isAssignVehicleInProgress: 'isAssignVehicleInProgress',
  assignVehicleToUserSuccess: 'assignVehicleToUserSuccess',
  hasAssignVehicleFailed: 'hasAssignVehicleFailed',
  hasUnassignVehicleFromUserFailed: 'hasUnassignVehicleFromUserFailed',
  isUnassignVehicleFromUserInProgress: 'isUnassignVehicleFromUserInProgress',
  unassignVehicleToUserSuccess: 'unassignVehicleToUserSuccess',
  editVehicle: 'editVehicle',
  editVehicleInProgress: 'editVehicleInProgress',
  editVehicleSuccess: 'editVehicleSuccess',
  editVehicleFailed: 'editVehicleFailed',
  uploadPetFileFail: 'uploadPetFileFail',
  uploadPetFileInProgress: 'uploadPetFileInProgress',
  uploadPetFileSuccess: 'uploadPetFileSuccess',
  createNewPetFail: 'createNewPetFail',
  createNewPetinProgress: 'createNewPetinProgress',
  createNewPetSuccess: 'createNewPetSuccess',
  updatePetInProgress: 'updatePetInProgress',
  updatePetSuccess: 'updatePetSuccess',
  updatePetFail: 'updatePetFail',
  setIndividualForPet: 'setIndividualForPet',
  setTotalGuards: 'setTotalGuards',
  setTotalEnabledUsers: 'setTotalEnabledUsers',
  setTotalDisabledUsers: 'setTotalDisabledUsers',
  assingExistingUserInProgress: 'assingExistingUserInProgress',
  assingExistingUserSuccess: 'assingExistingUserSuccess',
  assingExistingUserFail: 'assingExistingUserFail',
  findUserCredentialsInProgress: 'findUserCredentialsInProgress',
  findUserCredentialsSuccess: 'findUserCredentialsSuccess',
  findUserCredentialsFailed: 'findUserCredentialsFailed',
  updateUserCredentialsInProgress: 'updateUserCredentialsInProgress',
  updateUserCredentialsKeenvilSuccess: 'updateUserCredentialsKeenvilSuccess',
  updateUserCredentialsSuccess: 'updateUserCredentialsSuccess',
  updateUserCredentialsFailed: 'updateUserCredentialsFailed',
  clearUserCredentialsStatus: 'clearUserCredentialsStatus',
  setUserCredentialsSyncStatus: 'setUserCredentialsSyncStatus',
  findAppPermissionsInProgress: 'findAppPermissionsInProgress',
  findAppPermissionsSuccess: 'findAppPermissionsSuccess',
  findAppPermissionsFailed: 'findAppPermissionsFailed',
  updateAppPermissionInProgress: 'updateAppPermissionInProgress',
  updateAppPermissionSuccess: 'updateAppPermissionSuccess',
  updateAppPermissionFailed: 'updateAppPermissionFailed',
  clearAppPermissionStatus: 'clearAppPermissionStatus'
};

const createNewPetFail = createAction(types.createNewPetFail);
const createNewPetinProgress = createAction(types.createNewPetinProgress);
const createNewPetSuccess = createAction(types.createNewPetSuccess);

const updatePetInProgress = createAction(types.updatePetInProgress);
const updatePetSuccess = createAction(types.updatePetSuccess);
const updatePetFail = createAction(types.updatePetFail);

const editVehicleInProgress = createAction(types.editVehicleInProgress);
const editVehicleSuccess = createAction(types.editVehicleSuccess);
const editVehicleFailed = createAction(types.editVehicleFailed);

const uploadPetFileFail = createAction(types.uploadPetFileFail);
const uploadPetFileInProgress = createAction(types.uploadPetFileInProgress);
const uploadPetFileSuccess = createAction(types.uploadPetFileSuccess);
const queryUsersSuccess = createAction(types.queryUsersSuccess);
const queryUsersInProgress = createAction(types.queryUsersInProgress);
const queryUsersFailed = createAction(types.queryUsersFailed);
const findUserByIdSuccess = createAction(types.findUserByIdSuccess);
const findUserByIdInProgress = createAction(types.findUserByIdInProgress);
const findUserByIdFailed = createAction(types.findUserByIdFailed);
const updateUserByIdSuccess = createAction(types.updateUserByIdSuccess);
const updateUserByIdInProgress = createAction(types.updateUserByIdInProgress);
const updateUserByIdFailed = createAction(types.updateUserByIdFailed);
const deleteUserByIdSuccess = createAction(types.deleteUserByIdSuccess);
const deleteUserByIdInProgress = createAction(types.deleteUserByIdInProgress);
const deleteUserByIdFailed = createAction(types.deleteUserByIdFailed);
const createUserSuccess = createAction(types.createUserSuccess);
const createUserInProgress = createAction(types.createUserInProgress);
const createUserFailed = createAction(types.createUserFailed);
const sendWelcomeEmailInProgress = createAction(
  types.sendWelcomeEmailInProgress
);
const sendWelcomeEmailSuccess = createAction(types.sendWelcomeEmailSuccess);
const sendWelcomeEmailFailed = createAction(types.sendWelcomeEmailFailed);
const resendInvitationEmailInProgress = createAction(
  types.resendInvitationEmailInProgress
);
const resendInvitationEmailSuccess = createAction(
  types.resendInvitationEmailSuccess
);
const resendInvitationEmailFailed = createAction(
  types.resendInvitationEmailFailed
);
const clearEmailSuccess = createAction(types.clearEmailSuccess);
const queryUnitsSuccess = createAction(types.queryUnitsSuccess);
const queryUnitsInProgress = createAction(types.queryUnitsInProgress);
const queryUnitsFailed = createAction(types.queryUnitsFailed);
const clearUnits = createAction(types.clearUnits);
const addUnitToSelection = createAction(types.addUnitToSelection);
const removeUnitFromSelection = createAction(types.removeUnitFromSelection);
const updateSelectedUnitRelationship = createAction(
  types.updateSelectedUnitRelationship
);
const assignUnitsToUserSuccess = createAction(types.assignUnitsToUserSuccess);
const assignUnitsToUserInProgress = createAction(
  types.assignUnitsToUserInProgress
);
const assignUnitsToUserFailed = createAction(types.assignUnitsToUserFailed);
const unassignUnitFromUserSuccess = createAction(
  types.unassignUnitFromUserSuccess
);
const unassignUnitFromUserInProgress = createAction(
  types.unassignUnitFromUserInProgress
);
const unassignUnitFromUserFailed = createAction(
  types.unassignUnitFromUserFailed
);

const changeIndividualStatusInCommunityInProgress = createAction(
  types.changeIndividualStatusInCommunityInProgress
);

const changeIndividualStatusInCommunitySuccess = createAction(
  types.changeIndividualStatusInCommunitySuccess
);

const changeIndividualStatusInCommunityFailed = createAction(
  types.changeIndividualStatusInCommunityFailed
);

const isUnassignVehicleFromUserInProgress = createAction(
  types.isUnassignVehicleFromUserInProgress
);
const assignVehicleToUserSuccess = createAction(
  types.assignVehicleToUserSuccess
);
const hasAssignVehicleFailed = createAction(types.hasAssignVehicleFailed);

const isAssignVehicleInProgress = createAction(types.isAssignVehicleInProgress);
const unassignVehicleToUserSuccess = createAction(
  types.unassignVehicleToUserSuccess
);
const hasUnassignVehicleFromUserFailed = createAction(
  types.hasUnassignVehicleFromUserFailed
);

const assingExistingUserInProgress = createAction(
  types.assingExistingUserInProgress
);
const assingExistingUserSuccess = createAction(types.assingExistingUserSuccess);
const assingExistingUserFail = createAction(types.assingExistingUserFail);
const findUserCredentialsInProgress = createAction(
  types.findUserCredentialsInProgress
);
const findUserCredentialsSuccess = createAction(
  types.findUserCredentialsSuccess
);
const findUserCredentialsFailed = createAction(types.findUserCredentialsFailed);
const updateUserCredentialsInProgress = createAction(
  types.updateUserCredentialsInProgress
);
const updateUserCredentialsKeenvilSuccess = createAction(
  types.updateUserCredentialsKeenvilSuccess
);
const updateUserCredentialsSuccess = createAction(
  types.updateUserCredentialsSuccess
);
const updateUserCredentialsFailed = createAction(
  types.updateUserCredentialsFailed
);
const clearUserCredentialsStatus = createAction(
  types.clearUserCredentialsStatus
);
const findAppPermissionsInProgress = createAction(
  types.findAppPermissionsInProgress
);
const findAppPermissionsSuccess = createAction(types.findAppPermissionsSuccess);
const findAppPermissionsFailed = createAction(types.findAppPermissionsFailed);
const updateAppPermissionInProgress = createAction(
  types.updateAppPermissionInProgress
);
const updateAppPermissionSuccess = createAction(
  types.updateAppPermissionSuccess
);
const updateAppPermissionFailed = createAction(types.updateAppPermissionFailed);
const clearAppPermissionStatus = createAction(types.clearAppPermissionStatus);
const setTotalGuards = createAction(types.setTotalGuards);
const setTotalEnabledUsers = createAction(types.setTotalEnabledUsers);
const setTotalDisabledUsers = createAction(types.setTotalDisabledUsers);

const dssSyncedStatuses = ['SYNCED', 'FROZEN'];
const isTestEnvironment = process.env.NODE_ENV === 'test';
const dssSyncPollIntervalMs = isTestEnvironment ? 10 : 1500;
const dssSyncTimeoutMs = isTestEnvironment ? 100 : 30000;
const dssSyncSuccessSettleMs = isTestEnvironment ? 30 : 4500;

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Parses `lastAttemptedAt`/`lastSyncedAt` tolerantly: the backend may
 * serialize a Java `LocalDateTime` either as an ISO-8601 string or as a
 * Jackson array `[year, month, day, hour, minute, second, nano]` (months
 * are 1-based there, unlike JS `Date`). Returns a timestamp usable only to
 * detect "did this value change", never compared against the browser's
 * clock (that introduces clock-skew and used to make the DSS verification
 * for card/code credentials time out even when DSS had applied the change
 * — same root cause as fix #1 in castleblack-fixes-zonas-dss.md, here for
 * credentials instead of zones).
 */
const parseSyncTimestamp = value => {
  if (value == null) {
    return null;
  }

  if (Array.isArray(value)) {
    const [
      year,
      month,
      day,
      hour = 0,
      minute = 0,
      second = 0,
      nano = 0
    ] = value;

    if (year == null || month == null || day == null) {
      return null;
    }

    const timestamp = new Date(
      year,
      month - 1,
      day,
      hour,
      minute,
      second,
      Math.floor(nano / 1e6)
    ).getTime();

    return Number.isNaN(timestamp) ? null : timestamp;
  }

  const timestamp = new Date(value).getTime();
  return Number.isNaN(timestamp) ? null : timestamp;
};

const getSyncStatusTimestampKey = syncStatus => {
  const raw =
    (syncStatus && syncStatus.lastAttemptedAt) ||
    (syncStatus && syncStatus.lastSyncedAt);
  const parsed = parseSyncTimestamp(raw);
  // Fall back to the raw value (stringified) so that even if it can't be
  // parsed we can still detect that the backend reported a new attempt.
  return parsed != null ? parsed : raw ? JSON.stringify(raw) : null;
};

const createDssSyncError = syncStatus => {
  const syncError =
    syncStatus && syncStatus.syncError
      ? syncStatus.syncError
      : 'No se pudo aplicar el cambio en DSS.';

  return {
    apiErrors: [
      {
        message: syncError
      }
    ],
    dssSyncStatus: syncStatus
  };
};

const createDssSyncTimeoutError = syncStatus => {
  return {
    apiErrors: [
      {
        message: 'No se pudo confirmar la aplicación en DSS.'
      }
    ],
    dssSyncStatus: {
      ...syncStatus,
      syncStatus: syncStatus ? syncStatus.syncStatus : 'TIMEOUT',
      syncError: 'No se pudo confirmar la aplicación en DSS.'
    }
  };
};

const createDssSyncUnavailableError = error => {
  return {
    apiErrors:
      error && error.apiErrors && error.apiErrors.length > 0
        ? error.apiErrors
        : [
            {
              message: 'No se pudo verificar el estado en DSS.'
            }
          ],
    dssSyncStatus: {
      syncStatus: 'UNVERIFIED',
      syncError: 'No se pudo verificar el estado en DSS.'
    }
  };
};

const pollIndividualDssSyncStatus = (
  communityModule,
  communityId,
  individualId,
  timeoutMs = dssSyncTimeoutMs,
  pollIntervalMs = dssSyncPollIntervalMs
) => {
  const pollingStartedAt = Date.now();
  let latestSyncStatus = null;
  let latestFailedStatus = null;
  let successSince = null;
  let successTimestampKey = null;

  const poll = () => {
    return communityModule
      .findIndividualZoneAccessSyncStatus(communityId, individualId)
      .then(syncStatus => {
        latestSyncStatus = syncStatus;
        const status = syncStatus && syncStatus.syncStatus;

        if (dssSyncedStatuses.includes(status)) {
          const timestampKey = getSyncStatusTimestampKey(syncStatus);

          if (successTimestampKey !== timestampKey) {
            successTimestampKey = timestampKey;
            successSince = Date.now();
          }

          if (Date.now() - successSince >= dssSyncSuccessSettleMs) {
            return syncStatus;
          }
        } else {
          successSince = null;
          successTimestampKey = null;

          if (status === 'FAILED') {
            latestFailedStatus = syncStatus;
          }
        }

        if (Date.now() - pollingStartedAt >= timeoutMs) {
          if (latestFailedStatus) {
            return Promise.reject(createDssSyncError(latestFailedStatus));
          }

          return Promise.reject(createDssSyncTimeoutError(latestSyncStatus));
        }

        return wait(pollIntervalMs).then(poll);
      })
      .catch(error => {
        if (error && error.dssSyncStatus) {
          return Promise.reject(error);
        }

        return Promise.reject(createDssSyncUnavailableError(error));
      });
  };

  return poll();
};

/**
 *
 * @param {Object} query query filter object.
 *                 Contains q, page, limit, and sort.
 *                 All optionals.
 */
const countUsers = () => {
  return (dispatch, getState, Api) => {
    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    communityModule
      .queryUsers({
        type: allProfileTypes.SECURITY,
        status: statusTypes.ENABLED
      })
      .then(response => {
        const totalElements = response.individuals.totalElements;
        dispatch(setTotalGuards(totalElements));
      });

    communityModule
      .queryUsers({ status: statusTypes.DISABLED })
      .then(response => {
        const totalElements = response.individuals.totalElements;
        dispatch(setTotalDisabledUsers(totalElements));
      });

    communityModule
      .queryUsers({
        type: allProfileTypes.RESIDENT,
        status: statusTypes.ENABLED
      })
      .then(response => {
        const totalElements = response.individuals.totalElements;
        dispatch(setTotalEnabledUsers(totalElements));
      });

    return Promise.resolve();
  };
};

const queryUsers = query => {
  return (dispatch, getState, Api) => {
    dispatch(queryUsersInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule
      .queryUsers(query)
      .then(response => {
        dispatch(queryUsersSuccess(response));
        const type = query.type;
        const status = query.status;

        const totalElements = response.individuals.totalElements;

        if (status === statusTypes.ENABLED) {
          if (type === allProfileTypes.SECURITY) {
            dispatch(setTotalGuards(totalElements));
          } else {
            dispatch(setTotalEnabledUsers(totalElements));
          }
        } else {
          dispatch(setTotalDisabledUsers(totalElements));
        }
      })
      .catch(error => {
        dispatch(
          queryUsersFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

/**
 * Morosidad por unidad del individuo: `GET individuals/{id}/units` trae en cada unidad
 * `accessSuspended` + `activeAccessSuspension` (una sola consulta). Resuelve con un mapa
 * unitId -> episodio activo, solo de las unidades en mora. Sin estado en redux: lo usa
 * el resumen del usuario para la (M).
 */
const findIndividualUnitSuspensions = individualId => {
  return (dispatch, getState, Api) => {
    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule.findIndividualUnits(individualId).then(units =>
      (units || []).reduce((suspended, unit) => {
        if (unit && unit.accessSuspended === true) {
          suspended[unit.id] = unit.activeAccessSuspension || {};
        }
        return suspended;
      }, {})
    );
  };
};

const findUserById = id => {
  return (dispatch, getState, Api) => {
    dispatch(findUserByIdInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule
      .findUserById(id)
      .then(response => {
        const normalProfiles = response.profiles.filter(
          profile => !isEmpty(normalProfileTypes[profile.type])
        );
        const unitsIds = normalProfiles.map(profile => profile?.unit?.id);

        if (!isEmpty(unitsIds)) {
          dispatch(
            unitsActions.findMultipleUnitsByIds(unitsIds, unitsIds, response)
          );
        } else {
          dispatch(findUserByIdSuccess(response));
        }
      })
      .catch(error => {
        dispatch(
          findUserByIdFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const updateUserById = user => {
  return (dispatch, getState, Api) => {
    dispatch(updateUserByIdInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    const serializedUser = serialize(user);

    return communityModule
      .updateUserById(serializedUser)
      .then(response => {
        dispatch(updateUserByIdSuccess(response));
        return Promise.resolve(response);
      })
      .catch(error => {
        dispatch(
          updateUserByIdFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

// Who already uses an email (404 = nobody). Does not touch the store: the
// "Datos personales" form uses it to warn before saving a repeated email.
const findIndividualByEmail = email => {
  return (dispatch, getState, Api) => {
    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule.findByEmail(email);
  };
};

// Quién tiene un documento (404 = nadie). Mismo uso que findIndividualByEmail.
const findIndividualByDocument = ({ idType, number, idCountry }) => {
  return (dispatch, getState, Api) => {
    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule.getIndividuals({ idType, number, idCountry });
  };
};

const deleteUserById = user => {
  return (dispatch, getState, Api) => {
    dispatch(deleteUserByIdInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule
      .deleteUserById(user)
      .then(response => {
        dispatch(deleteUserByIdSuccess(response));
      })
      .catch(error => {
        dispatch(
          deleteUserByIdFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const uploadPetImage = image => {
  return (dispatch, getState, Api) => {
    dispatch(uploadPetFileInProgress());

    const securityModule = Api.getModule('security');
    securityModule.adapter.token = getState().session.user.token;
    securityModule.adapter.communityId = getState().session.profile.community.id;

    return securityModule
      .uploadFile({
        name: image.name,
        bytes: image.image
      })
      .then(response => {
        dispatch(uploadPetFileSuccess(response));
      })
      .catch(error => {
        dispatch(
          uploadPetFileFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const createNewPet = petObject => {
  return (dispatch, getState, Api) => {
    dispatch(createNewPetinProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule
      .addNewPetToUser(petObject)
      .then(response => {
        dispatch(createNewPetSuccess(response));
        dispatch(findUserById(petObject.userId));
      })
      .catch(error => {
        dispatch(
          createNewPetFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const createUser = (
  user,
  type,
  units,
  guardProfile,
  contractsPerUnits,
  specificUnit = false
) => {
  return (dispatch, getState, Api) => {
    dispatch(createUserInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    const serializedUser = serialize(
      user,
      type,
      units,
      guardProfile,
      contractsPerUnits
    );

    const queryType = type != 'resident' ? 'SECURITY' : 'RESIDENT';

    return communityModule
      .createUser(serializedUser)
      .then(response => {
        if (specificUnit) {
          const unit = getState().users.createWizard.selectedUnits[0];
          dispatch(unitsActions.findUnitById(unit.id)).then(res => {
            dispatch(userWizzardAction.closeCreateUserWizard());
          });
        } else {
          dispatch(
            queryUsers({
              page: 0,
              limit: 25,
              type: queryType,
              status: statusTypes.ENABLED
            })
          );
        }
        dispatch(createUserSuccess(response));
        dispatch(userWizzardAction.closeCreateUserWizard());
        return response;
      })
      .catch(error => {
        dispatch(
          createUserFailed({
            apiError: error.apiErrors
          })
        );
        throw error;
      });
  };
};

const sendWelcomeEmail = userId => {
  return (dispatch, getState, Api) => {
    dispatch(sendWelcomeEmailInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule
      .sendWelcomeEmail(userId)
      .then(response => {
        dispatch(sendWelcomeEmailSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(
          sendWelcomeEmailFailed({
            apiError: error.apiErrors
          })
        );
        throw error;
      });
  };
};

const resendInvitationEmail = () => {
  return (dispatch, getState, Api) => {
    dispatch(resendInvitationEmailInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule
      .resendInvitationEmail()
      .then(response => {
        dispatch(resendInvitationEmailSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(
          resendInvitationEmailFailed({
            apiError: error.apiErrors
          })
        );
        throw error;
      });
  };
};

/**
 * Query the units of the active community.
 * @param {Object} queryObject is the query sent by the auto-complete
 *                              component
 */
const queryUnits = queryObject => {
  return (dispatch, getState, Api) => {
    dispatch(queryUnitsInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    const query = {
      q: queryObject.value,
      empty: false
    };

    return communityModule
      .queryUnits(query)
      .then(response => {
        dispatch(queryUnitsSuccess(response));
      })
      .catch(error => {
        dispatch(
          queryUnitsFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const assignUnitsToUser = () => {
  return (dispatch, getState, Api) => {
    dispatch(assignUnitsToUserInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    const { users } = getState();

    const { currentUser, currentUserSelectedUnits } = users;

    const serializedUnits = currentUserSelectedUnits.map(unit => {
      return {
        id: unit.id,
        profileType: unit.relationship
      };
    });

    return communityModule
      .assignUnitsToUser(currentUser.id, serializedUnits)
      .then(response => {
        dispatch(assignUnitsToUserSuccess(response));
        return Promise.resolve(response);
      })
      .catch(error => {
        dispatch(
          assignUnitsToUserFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject();
      });
  };
};

const assignUnitsWithContracts = (
  user,
  units,
  contractsPerUnits,
  withSpecificUnit = false
) => {
  return (dispatch, getState, Api) => {
    dispatch(assignUnitsToUserInProgress());

    const contracts = contractsPerUnits.map(contract => contract.contractData);

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    const serializedUser = serialize(user, 'resident', units, null, contracts);

    return communityModule
      .createUser(serializedUser)
      .then(response => {
        dispatch(assignUnitsToUserSuccess(response));
        if (withSpecificUnit) {
          const unit = getState().users.createWizard.selectedUnits[0];
          dispatch(unitsActions.findUnitById(unit.id)).then(res => {
            dispatch(userWizzardAction.closeCreateUserWizard());
          });
        }
        dispatch(findUserById(user.id, true));
        return Promise.resolve(response);
      })
      .catch(error => {
        dispatch(
          assignUnitsToUserFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

const unassignUnitFromUser = (userId, unitId) => {
  return (dispatch, getState, Api) => {
    dispatch(unassignUnitFromUserInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule
      .unassignUnitFromUser(userId, unitId)
      .then(() => {
        dispatch(unassignUnitFromUserSuccess());
        //Fetches user again to bring the updated profile...
        dispatch(findUserById(userId, true));
        return Promise.resolve();
      })
      .catch(error => {
        dispatch(
          unassignUnitFromUserFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject();
      });
  };
};

const editVehicle = (ids, newData) => {
  return (dispatch, getState, Api) => {
    dispatch(editVehicleInProgress());
    //ids contain {user, vehicle, unit}
    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule
      .editVehicle(ids.user, ids.unit, ids.vehicle, newData)
      .then(res => {
        dispatch(editVehicleSuccess(res));
        dispatch(findUserById(ids.user));
      })
      .catch(err => {
        dispatch(editVehicleFailed(err.apiError));
      });
  };
};

const changeIndividualStatusInCommunity = (userId, status) => {
  return (dispatch, getState, Api) => {
    dispatch(changeIndividualStatusInCommunityInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    let user = getUserById(getState().users, userId);
    const currentUser = getCurrentUser(getState());

    if (!user) {
      if (currentUser.id !== userId) {
        return Promise.resolve();
      } else {
        user = currentUser;
      }
    }

    let profile;

    if (status === 'DISABLED') {
      profile = getUserProfile(user);
    } else {
      profile = getDisabledProfile(user);
    }

    return communityModule
      .changeIndividualStatus(user.id, profile.id, { status })
      .then(response => {
        dispatch(
          changeIndividualStatusInCommunitySuccess({
            individual: response
          })
        );
        return Promise.resolve();
      })
      .catch(error => {
        dispatch(
          changeIndividualStatusInCommunityFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject();
      });
  };
};

const enableUnitStatusByProfile = (userId, profileId) => {
  return (dispatch, getState, Api) => {
    dispatch(changeIndividualStatusInCommunityInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    const currentUser = getCurrentUser(getState());
    const accountActive = currentUser.accountInfo.status === statusTypes.ACTIVE;

    return communityModule
      .changeIndividualStatus(userId, profileId, {
        status: statusTypes.ENABLED
      })
      .then(response => {
        dispatch(
          changeIndividualStatusInCommunitySuccess({
            individual: response
          })
        );
        if (!accountActive) {
          dispatch(sendWelcomeEmail(userId));
        }
        dispatch(findUserById(currentUser.id));
        return Promise.resolve();
      })
      .catch(error => {
        dispatch(
          changeIndividualStatusInCommunityFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject();
      });
  };
};

const disableUnitStatusByProfile = (userId, profileId) => {
  return (dispatch, getState, Api) => {
    dispatch(changeIndividualStatusInCommunityInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    const currentUser = getCurrentUser(getState());

    return communityModule
      .changeIndividualStatus(userId, profileId, {
        status: statusTypes.DISABLED
      })
      .then(response => {
        dispatch(
          changeIndividualStatusInCommunitySuccess({
            individual: response
          })
        );
        dispatch(findUserById(currentUser.id));
        return Promise.resolve();
      })
      .catch(error => {
        dispatch(
          changeIndividualStatusInCommunityFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject();
      });
  };
};

const setupCommunityModule = (getState, Api) => {
  const communityModule = Api.getModule('community');
  communityModule.adapter.token = getState().session.user.token;
  communityModule.adapter.communityId = getState().session.profile.community.id;
  return communityModule;
};

const setupSecurityModuleForReauth = (getState, Api) => {
  const securityModule = Api.getModule('security');
  securityModule.adapter.communityId = null;
  securityModule.adapter.token = null;
  securityModule.adapter.applicationId = 'CASTLEBLACK';
  securityModule.adapter.operatingSystem = 'BROWSER';
  return securityModule;
};

const readEmail = value => (typeof value === 'string' ? value.trim() : '');

const emailFromAccessToken = token => {
  if (!token || typeof token !== 'string') {
    return '';
  }

  const parts = token.split('.');
  if (parts.length < 2) {
    return '';
  }

  try {
    const payload = JSON.parse(
      atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
    );
    return readEmail(payload.email || payload.user_name || payload.username);
  } catch (error) {
    return '';
  }
};

const getLoggedAdminEmail = state => {
  const user = state.session.user || {};

  return (
    readEmail(user.email) ||
    readEmail(user.accountInfo && user.accountInfo.email) ||
    readEmail(user.account && user.account.email) ||
    emailFromAccessToken(user.token)
  );
};

const normalizePermissionCatalog = catalog => {
  const permissions = Array.isArray(catalog)
    ? catalog
    : Array.isArray(catalog?.content)
    ? catalog.content
    : [];

  return permissions.filter(
    permission => `${permission.category}`.toLowerCase() === 'residente'
  );
};

const normalizeProfilePermissionKeys = permissions => {
  // El backend responde { permissions: Set<String> } (PermissionsResponse),
  // tanto en el GET como en el PUT/DELETE de grant/revoke — no un array
  // pelado. Sin el `.permissions` acá, enabledKeys queda siempre vacío y
  // todos los permisos se ven "OFF" aunque estén otorgados.
  const values = Array.isArray(permissions)
    ? permissions
    : Array.isArray(permissions?.content)
    ? permissions.content
    : Array.isArray(permissions?.permissions)
    ? permissions.permissions
    : [];

  return values
    .map(permission =>
      typeof permission === 'string'
        ? permission
        : permission.permissionKey ||
          permission.key ||
          permission.permission_key
    )
    .filter(Boolean);
};

const getApiErrorMessage = error => {
  const apiError = error && error.apiErrors && error.apiErrors[0];

  return (
    (apiError && (apiError.message || apiError.description || apiError.code)) ||
    error?.message ||
    'No se pudo completar la operación.'
  );
};

const findCurrentUserResidentProfiles = state => {
  const currentUser = getCurrentUser(state);
  const communityId = state.session.profile.community.id;
  const profiles = currentUser?.profiles || [];

  return profiles.filter(
    profile =>
      `${profile.community?.id}` === `${communityId}` &&
      normalProfileTypes[profile.type] != null
  );
};

const isNotFoundError = error => {
  const apiError = error && error.apiErrors && error.apiErrors[0];
  const status =
    (error && error.status) ||
    (error && error.httpStatus) ||
    (error && error.response && error.response.status) ||
    (apiError && apiError.status) ||
    (apiError && apiError.httpStatus);
  const message =
    (apiError && apiError.message) ||
    (apiError && apiError.description) ||
    (error && error.message);

  return `${status}` === '404' || message === 'Not Found';
};

const findUserCredentials = userId => {
  return (dispatch, getState, Api) => {
    dispatch(findUserCredentialsInProgress({ userId }));

    const communityModule = setupCommunityModule(getState, Api);

    return communityModule
      .findIndividualCredentials(userId)
      .then(credentials => {
        dispatch(
          findUserCredentialsSuccess({
            userId,
            credentials
          })
        );
        return credentials;
      })
      .catch(error => {
        if (isNotFoundError(error)) {
          const emptyCredentials = {};
          dispatch(
            findUserCredentialsSuccess({
              userId,
              credentials: emptyCredentials
            })
          );
          return emptyCredentials;
        }

        dispatch(
          findUserCredentialsFailed({
            apiError: error.apiErrors
          })
        );
        throw error;
      });
  };
};

const findUserAppPermissions = userId => {
  return (dispatch, getState, Api) => {
    const profiles = findCurrentUserResidentProfiles(getState());
    const profileIds = profiles.map(profile => profile.id);

    dispatch(
      findAppPermissionsInProgress({
        userId,
        profileIds
      })
    );

    if (!profileIds.length) {
      const apiError = [{ message: 'No se encontró perfil residente.' }];
      dispatch(findAppPermissionsFailed({ apiError }));
      return Promise.reject({ apiErrors: apiError });
    }

    const communityModule = setupCommunityModule(getState, Api);

    return Promise.all([
      communityModule.findPermissionsCatalog(),
      Promise.all(
        profileIds.map(profileId =>
          communityModule
            .findIndividualProfilePermissions(userId, profileId)
            .then(permissionKeys => ({
              profileId,
              keys: normalizeProfilePermissionKeys(permissionKeys)
            }))
        )
      )
    ])
      .then(([catalog, profilePermissions]) => {
        const residentCatalog = normalizePermissionCatalog(catalog);
        const keysByProfile = {};

        profilePermissions.forEach(({ profileId, keys }) => {
          keysByProfile[profileId] = keys;
        });

        dispatch(
          findAppPermissionsSuccess({
            userId,
            catalog: residentCatalog,
            keysByProfile,
            profiles: profiles.map(profile => ({
              id: profile.id,
              type: profile.type,
              unit: profile.unit || null
            }))
          })
        );

        return {
          catalog: residentCatalog,
          keysByProfile
        };
      })
      .catch(error => {
        dispatch(
          findAppPermissionsFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

const revalidateAdminPassword = password => {
  return (dispatch, getState, Api) => {
    const email = getLoggedAdminEmail(getState());
    const securityModule = setupSecurityModuleForReauth(getState, Api);

    if (!email) {
      return Promise.reject({
        apiErrors: [{ message: 'No se encontró el email del admin.' }]
      });
    }

    if (typeof password !== 'string' || password.length === 0) {
      return Promise.reject({
        apiErrors: [{ message: 'La contraseña es requerida.' }]
      });
    }

    return verifyAdminPassword(securityModule, email, password).catch(error =>
      Promise.reject({
        apiErrors: [
          {
            message:
              getApiErrorMessage(error) === 'Unauthorized'
                ? 'Contraseña incorrecta.'
                : 'Contraseña incorrecta.'
          }
        ]
      })
    );
  };
};

/**
 * Aplica los cambios de permisos en orden por perfil: cada PUT/DELETE de un
 * mismo perfil relee y reescribe su JSON de permisos en el backend, así que
 * mandarlos en paralelo hace que las llamadas se pisen entre sí (el último
 * en escribir gana y los demás "se pierden" aunque respondan 2xx). Los
 * cambios de perfiles distintos no comparten estado y siguen en paralelo.
 * Devuelve los resultados en el mismo orden que `changes`.
 */
const applyChangesPerProfile = (changes, applyChange, defaultProfileId) => {
  const groups = {};

  changes.forEach((change, index) => {
    const target =
      change.profileId != null ? change.profileId : defaultProfileId;
    const key = String(target);

    groups[key] = groups[key] || [];
    groups[key].push({ change, index });
  });

  return Promise.all(
    Object.keys(groups).map(key =>
      groups[key].reduce(
        (chain, { change, index }) =>
          chain.then(done =>
            applyChange(change).then(result => done.concat({ result, index }))
          ),
        Promise.resolve([])
      )
    )
  ).then(groupResults =>
    groupResults
      .reduce((all, group) => all.concat(group), [])
      .sort((a, b) => a.index - b.index)
      .map(({ result }) => result)
  );
};

/**
 * Cambios que el backend respondió como OK pero que el estado releído no
 * refleja. Si no hay estado releído (el refresh falló) o el perfil no está
 * entre los releídos, no se puede verificar y no se marca nada.
 */
const findNotPersistedChanges = (results, refreshed) => {
  const keysByProfile = refreshed && refreshed.keysByProfile;

  if (!keysByProfile) {
    return [];
  }

  return results.filter(result => {
    const keys = keysByProfile[result.profileId];

    return (
      result.ok &&
      Array.isArray(keys) &&
      keys.includes(result.permissionKey) !== result.enabled
    );
  });
};

/**
 * Applies a batch of app-permission changes with a single step-up
 * (password revalidated once, not per permission) and a single `reason`
 * (the human justification — NOT a concatenation of permission names;
 * audit already records permission+action per row, so the reason field
 * only needs to carry the "why").
 *
 * `changes` is `[{ profileId, permissionKey, enabled }, ...]`. Each change
 * is applied as its own PUT (grant) or DELETE (revoke) against that
 * profile. A single password check and `reason` cover the whole save.
 * Failures in one change don't stop the rest from being tried.
 */
const updateUserAppPermissions = ({
  userId,
  profileId,
  changes,
  reason,
  password
}) => {
  return (dispatch, getState, Api) => {
    dispatch(updateAppPermissionInProgress({ changes }));

    if (!changes || changes.length === 0) {
      const apiError = [{ message: 'No hay cambios para guardar.' }];
      dispatch(updateAppPermissionFailed({ apiError }));
      return Promise.reject({ apiErrors: apiError });
    }

    const communityModule = setupCommunityModule(getState, Api);

    const applyChange = ({
      profileId: changeProfileId,
      permissionKey,
      enabled
    }) => {
      const targetProfileId =
        changeProfileId != null ? changeProfileId : profileId;
      // Grant (PUT) y revoke (DELETE) mandan reason por query param: el
      // backend lo lee como @RequestParam, no del body JSON. Mandarlo en
      // el body tira 422 "reason is required" aunque el front sí lo mande.
      const request = enabled
        ? communityModule.grantIndividualProfilePermission(
            userId,
            targetProfileId,
            permissionKey,
            reason
          )
        : communityModule.revokeIndividualProfilePermission(
            userId,
            targetProfileId,
            permissionKey,
            reason
          );

      return request
        .then(() => ({
          profileId: targetProfileId,
          permissionKey,
          enabled,
          ok: true
        }))
        .catch(error => ({
          profileId: targetProfileId,
          permissionKey,
          enabled,
          ok: false,
          error
        }));
    };

    return dispatch(revalidateAdminPassword(password))
      .then(() => applyChangesPerProfile(changes, applyChange, profileId))
      .then(results =>
        // El refresh es best-effort: si falla, no debe tapar el resultado
        // real de los cambios que sí se intentaron aplicar.
        dispatch(findUserAppPermissions(userId))
          .catch(() => null)
          .then(refreshed => ({ results, refreshed }))
      )
      .then(({ results, refreshed }) => {
        const failed = results.filter(result => !result.ok);
        const notPersisted = findNotPersistedChanges(results, refreshed);

        if (failed.length === 0 && notPersisted.length > 0) {
          // Todas las llamadas respondieron 2xx pero el backend no refleja
          // el cambio: no se puede decir "todo aplicado".
          const applied = results.length - notPersisted.length;
          const list = notPersisted
            .map(
              change =>
                `${change.permissionKey} (${
                  change.enabled ? 'activar' : 'desactivar'
                })`
            )
            .join(', ');

          return Promise.reject({
            apiErrors: [
              {
                message: `${applied}/${results.length} permisos aplicados. No quedaron guardados: ${list}. Recargá la pantalla y volvé a intentar.`
              }
            ]
          });
        }

        if (failed.length > 0) {
          const firstError = failed[0].error;
          const detail =
            (firstError &&
              firstError.apiErrors &&
              firstError.apiErrors[0] &&
              firstError.apiErrors[0].message) ||
            getApiErrorMessage(firstError);
          const message =
            failed.length === results.length
              ? detail
              : `${results.length - failed.length}/${
                  results.length
                } permisos aplicados. ${detail}`;

          return Promise.reject({ apiErrors: [{ message }] });
        }

        dispatch(
          updateAppPermissionSuccess({
            message:
              results.length === 1
                ? results[0].enabled
                  ? 'Permiso activado en Keenvil ✓'
                  : 'Permiso desactivado en Keenvil ✓'
                : `${results.length} permisos actualizados en Keenvil ✓`
          })
        );
      })
      .catch(error => {
        const apiErrors = error.apiErrors || [
          { message: getApiErrorMessage(error) }
        ];

        dispatch(
          updateAppPermissionFailed({
            apiError: apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

const updateCredentialsAndRefresh = (
  userId,
  communityModule,
  request,
  operation
) => {
  return (dispatch, getState) => {
    dispatch(updateUserCredentialsInProgress({ userId, operation }));
    const communityId = getState().session.profile.community.id;

    return request().then(
      response => {
        dispatch(
          updateUserCredentialsKeenvilSuccess({
            credentials: response,
            keenvilSaved: true,
            operation
          })
        );
        return pollIndividualDssSyncStatus(communityModule, communityId, userId)
          .then(dssSyncStatus => {
            dispatch(
              updateUserCredentialsSuccess({
                credentials: response,
                dssSyncStatus,
                keenvilSaved: true,
                operation
              })
            );
            return dispatch(findUserCredentials(userId))
              .catch(() => null)
              .then(() => ({
                credentials: response,
                dssSyncStatus
              }));
          })
          .catch(error => {
            dispatch(
              updateUserCredentialsFailed({
                apiError: error.apiErrors,
                dssSyncStatus: error.dssSyncStatus,
                keenvilSaved: true,
                operation
              })
            );
            return dispatch(findUserCredentials(userId))
              .catch(() => null)
              .then(() => Promise.reject(error));
          });
      },
      error => {
        dispatch(
          updateUserCredentialsFailed({
            apiError: error.apiErrors,
            dssSyncStatus: null,
            keenvilSaved: false,
            operation
          })
        );
        throw error;
      }
    );
  };
};

const ignoreNotFoundForDelete = request => {
  return () =>
    request().catch(error => {
      if (isNotFoundError(error)) {
        return {};
      }

      throw error;
    });
};

const updateUserCardCredential = (userId, cardNumber, action = 'save') => {
  return (dispatch, getState, Api) => {
    const communityModule = setupCommunityModule(getState, Api);
    return dispatch(
      updateCredentialsAndRefresh(
        userId,
        communityModule,
        () =>
          communityModule.updateIndividualCardCredential(userId, cardNumber),
        { credential: 'card', action }
      )
    );
  };
};

const blockUserCardCredential = userId => {
  return (dispatch, getState, Api) => {
    const communityModule = setupCommunityModule(getState, Api);
    return dispatch(
      updateCredentialsAndRefresh(
        userId,
        communityModule,
        () => communityModule.blockIndividualCardCredential(userId),
        { credential: 'card', action: 'block' }
      )
    );
  };
};

const deleteUserCardCredential = userId => {
  return (dispatch, getState, Api) => {
    const communityModule = setupCommunityModule(getState, Api);
    return dispatch(
      updateCredentialsAndRefresh(
        userId,
        communityModule,
        ignoreNotFoundForDelete(() =>
          communityModule.deleteIndividualCardCredential(userId)
        ),
        { credential: 'card', action: 'delete' }
      )
    );
  };
};

const updateUserCodeCredential = (userId, accessCode, action = 'save') => {
  return (dispatch, getState, Api) => {
    const communityModule = setupCommunityModule(getState, Api);
    return dispatch(
      updateCredentialsAndRefresh(
        userId,
        communityModule,
        () =>
          communityModule.updateIndividualCodeCredential(userId, accessCode),
        { credential: 'code', action }
      )
    );
  };
};

const deleteUserCodeCredential = userId => {
  return (dispatch, getState, Api) => {
    const communityModule = setupCommunityModule(getState, Api);
    return dispatch(
      updateCredentialsAndRefresh(
        userId,
        communityModule,
        ignoreNotFoundForDelete(() =>
          communityModule.deleteIndividualCodeCredential(userId)
        ),
        { credential: 'code', action: 'delete' }
      )
    );
  };
};

const assignVehicleToUser = (unitId, vehicle, currentUser) => {
  return (dispatch, getState, Api) => {
    dispatch(isAssignVehicleInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule
      .assignVehicle(currentUser.id, unitId, vehicle)
      .then(response => {
        dispatch(assignVehicleToUserSuccess(response));
        dispatch(findUserById(currentUser.id));
      })
      .catch(error => {
        dispatch(
          hasAssignVehicleFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const unassignVehicleFromUser = (userId, vehicle) => {
  return async (dispatch, getState, Api) => {
    dispatch(isUnassignVehicleFromUserInProgress());

    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    const currentUser = getCurrentUser(getState());
    const units = getUserUnits(getResidentProfiles(currentUser.profiles));
    if (units.length === 0) {
      Promise.reject();
    }
    const vehicleUnit = await communityModule.getVehicleUnit(
      vehicle.individualGroup
    );
    await communityModule.unassignVehicle(
      currentUser.id,
      vehicleUnit.unit,
      vehicle.id
    );
    try {
      const response = await communityModule.getUserData(currentUser.id);
      if (response) {
        dispatch(unassignVehicleToUserSuccess(response));
        dispatch(findUserById(userId));
      }
    } catch (error) {
      dispatch(
        hasUnassignVehicleFromUserFailed({
          apiError: error.apiErrors
        })
      );
    }
  };
};

const changePasswordByAdmin = (accountId, newPassword) => {
  return (dispatch, getState, Api) => {
    const securityModule = Api.getModule('security');
    securityModule.adapter.token = getState().session.user.token;
    securityModule.adapter.communityId = getState().session.profile.community.id;

    return securityModule
      .changeUserPasswordByAdmin(accountId, newPassword)
      .then(res => {})
      .catch(err => {});
  };
};

const updatePet = pet => {
  return (dispatch, getState, Api) => {
    dispatch(updatePetInProgress());
    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule
      .updatePet(pet)
      .then(res => {
        dispatch(updatePetSuccess(res));
        dispatch(findUserById(pet.userId));
      })
      .catch(err => {
        dispatch(updatePetFail(err.apiErrors));
      });
  };
};

const getIndividual = individualId => {
  return (dispatch, getState, Api) => {
    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;

    return communityModule.getIndividual(individualId);
  };
};

const deletePet = (petId, userId, individualGroup) => {
  return (dispatch, getState, Api) => {
    const communityModule = Api.getModule('community');
    communityModule.adapter.token = getState().session.user.token;
    communityModule.adapter.communityId = getState().session.profile.community.id;
    const aux = group => dispatch(getIndividual(group));
    aux(individualGroup)
      .then(res => {
        return communityModule
          .deletePet(petId, userId, res?.unit)
          .then(() => {
            dispatch(findUserById(userId));
          })
          .catch(err => {});
      })
      .catch(() => false);
  };
};

export { types };
export default {
  findIndividualUnitSuspensions,
  deletePet,
  getIndividual,
  updatePet,
  queryUsers,
  findUserById,
  assignUnitsWithContracts,
  updateUserById,
  findIndividualByEmail,
  findIndividualByDocument,
  deleteUserById,
  createUser,
  sendWelcomeEmail,
  clearEmailSuccess,
  resendInvitationEmail,
  queryUnits,
  clearUnits,
  addUnitToSelection,
  removeUnitFromSelection,
  updateSelectedUnitRelationship,
  assignUnitsToUser,
  unassignUnitFromUser,
  changeIndividualStatusInCommunity,
  findUserCredentials,
  updateUserCardCredential,
  blockUserCardCredential,
  deleteUserCardCredential,
  updateUserCodeCredential,
  deleteUserCodeCredential,
  clearUserCredentialsStatus,
  findUserAppPermissions,
  updateUserAppPermissions,
  clearAppPermissionStatus,
  assignVehicleToUser,
  unassignVehicleFromUser,
  uploadPetImage,
  createNewPet,
  changePasswordByAdmin,
  editVehicle,
  findUserByIdSuccess,
  enableUnitStatusByProfile,
  disableUnitStatusByProfile,
  countUsers,
  assingExistingUserInProgress,
  assignUnitsToUserSuccess,
  assingExistingUserFail
};
